import { UIConfig } from "@dytesdk/ui-kit";
import DyteClient from "@dytesdk/web-core";

import { CustomStates, SetStates } from "../../../../../types/dyte";
import InMeeting from "./InMeeting";
import MeetingLoading from "./MeetingLoading";

function MeetingSetup({
  meeting,
  config,
  states,
  setStates,
  sessionId,
}: {
  meeting: DyteClient;
  config: UIConfig;
  states: CustomStates;
  setStates: SetStates;
  sessionId: string;
}) {
  if (states.meeting === "joined") {
    return (
      <InMeeting
        meeting={meeting}
        config={config}
        states={states}
        setStates={setStates}
        sessionId={sessionId}
      />
    );
  } else {
    return <MeetingLoading />;
  }
}

export default MeetingSetup;
